// extracted by mini-css-extract-plugin
export default {"editor":"pB6CMg","viewer":"FUtv2_","wired":"DNEi7g"};